import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconHome = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M31.474 1.942a2.7 2.7 0 0 0-.64.314c-.186.126-6.457 4.876-13.935 10.555C5.43 21.519 3.244 23.204 2.935 23.572a4.9 4.9 0 0 0-1.02 2.118c-.123.6-.125.942-.106 16.63.017 15.012.026 16.042.13 16.426.42 1.54 1.663 2.797 3.213 3.252.356.104.998.114 8.928.133 6.082.014 8.655 0 8.928-.052.629-.116 1.237-.62 1.519-1.256.064-.144.088-2.284.113-10.071l.032-9.888.14-.26c.076-.144.26-.37.406-.503.54-.487.035-.453 6.782-.453s6.242-.034 6.782.453c.147.133.33.36.407.503l.139.26.032 9.888c.025 7.732.05 9.927.112 10.069.281.633.881 1.138 1.488 1.252.229.043 3.323.07 8.832.079 7.757.012 8.518.004 8.922-.095 1.538-.375 2.86-1.68 3.285-3.241.107-.393.113-1.33.113-16.672 0-15.618-.005-16.274-.119-16.704a5.3 5.3 0 0 0-.888-1.792c-.291-.382-.75-.765-3.104-2.592l-2.761-2.144-.02-7.2-.02-7.2-.147-.275a2.5 2.5 0 0 0-.922-.922l-.275-.147-6.108-.017c-5.463-.016-6.14-.007-6.416.085-.39.13-.93.616-1.141 1.029-.153.298-.16.368-.18 1.7l-.02 1.388-3.465-2.598c-1.907-1.43-3.587-2.652-3.734-2.717-.36-.159-.943-.201-1.318-.096M19.04 16.222C11.886 21.655 6.047 26.13 5.968 26.246l-.145.207.017 15.708.016 15.707.151.123c.147.118.358.122 7.374.122h7.224l.018-8.816.018-8.816.144-.512c.163-.58.549-1.422.857-1.873.797-1.164 2.137-2.052 3.55-2.352.655-.138 12.961-.138 13.616 0a5.85 5.85 0 0 1 3.516 2.311c.323.453.72 1.305.89 1.914l.145.512.018 8.808.018 8.808 6.808.048c3.743.026 7 .035 7.238.02.355-.022.453-.054.552-.175.115-.143.119-.617.119-15.822 0-13.048-.015-15.71-.087-15.881-.066-.156-.832-.784-3.16-2.59-3.011-2.337-3.26-2.556-3.492-3.074-.058-.131-.085-1.817-.109-6.83l-.032-6.656-3.595-.017-3.595-.016-.021 2.354L44 11.811l-.213.433c-.378.767-1.11 1.185-1.96 1.116a2.1 2.1 0 0 1-.667-.172c-.152-.077-2.27-1.636-4.707-3.464-2.438-1.828-4.444-3.322-4.458-3.32s-5.845 4.42-12.955 9.819" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconHome.displayName = 'IconHome';